import { render, staticRenderFns } from "./topNavigation.vue?vue&type=template&id=2043bc0e&scoped=true"
import script from "./topNavigation.vue?vue&type=script&lang=js"
export * from "./topNavigation.vue?vue&type=script&lang=js"
import style0 from "./topNavigation.vue?vue&type=style&index=0&id=2043bc0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2043bc0e",
  null
  
)

export default component.exports